<template>
      <div class="Maintemplate">
        <v-app
            style="background: #EEEEEE;"
        >
        <MenuHeader></MenuHeader>
        <v-main>
          <v-container>
            <router-view></router-view>
          </v-container>
        </v-main>
        <!-- <Footer></Footer> -->
        </v-app>
      </div>
</template>
<script>
import MenuHeader from '@/components/MenuHeader/MenuHeader'
// import Footer from '@/components/Footer/Footer'
export default {
    name:'Maintemplate',
    components: {
      MenuHeader,
      // Footer
    },
    setup() {
        
    },
}
</script>